import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  UrlField,
} from 'react-admin';

export const ChainList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <UrlField source="url" />
    </Datagrid>
  </List>
);

export const ChainEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="uid" label="UID" />
      <TextInput source="name" />
      <TextInput source="url" type="url" />
    </SimpleForm>
  </Edit>
);

export const ChainCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="uid" label="UID" required />
      <TextInput source="name" required />
      <TextInput source="url" type="url" />
    </SimpleForm>
  </Create>
);

export const ChainShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <UrlField source="url" />
    </SimpleShowLayout>
  </Show>
);
